function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#menu-clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40.1458 7.6875H0.854193C0.382693 7.6875 0 8.07019 0 8.54169C0 9.01319 0.382693 9.39589 0.854193 9.39589H40.1459C40.6174 9.39589 41.0001 9.01319 41.0001 8.54169C41.0001 8.07019 40.6173 7.6875 40.1458 7.6875Z",
  fill: "#666666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.1458 19.6458H0.854193C0.382693 19.6458 0 20.0284 0 20.5C0 20.9715 0.382693 21.3541 0.854193 21.3541H40.1459C40.6174 21.3541 41.0001 20.9715 41.0001 20.5C41.0001 20.0284 40.6173 19.6458 40.1458 19.6458Z",
  fill: "#666666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.1458 31.6042H0.854193C0.382693 31.6042 0 31.9869 0 32.4584C0 32.9299 0.382693 33.3126 0.854193 33.3126H40.1459C40.6174 33.3126 41.0001 32.9299 41.0001 32.4584C41 31.9869 40.6173 31.6042 40.1458 31.6042Z",
  fill: "#666666"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "menu-clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 41,
  height: 41,
  fill: "white"
})));

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.38975579.svg";
export { ForwardRef as ReactComponent };